import { render, staticRenderFns } from "./AiQuestionaryBlock.vue?vue&type=template&id=55d1c023&scoped=true&"
import script from "./AiQuestionaryBlock.vue?vue&type=script&lang=ts&"
export * from "./AiQuestionaryBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AiQuestionaryBlock.vue?vue&type=style&index=0&id=55d1c023&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1c023",
  null
  
)

export default component.exports